module.exports = __webpack_public_path__ + "static/media/home_zz1.3e3484af.png";